export default __webpack_public_path__ + "static/media/trr-food-handheld-spicycrispychicken.ec54d588.png";